<template>
  <div
    class="container_medio container_com-fundo container_com-margem u-padding-grande edicao-da-solicitacao-mcmv-cidades">
    <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
    <form @submit.prevent="abrirModalDeEdicao">
      <h2 class="titulo titulo_grande u-margem-inferior grande">Edição das informações de solicitação</h2>
      <h3
        class="subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-grande">
        <i class="fal fa-user icone-de-titulo u-margem-direita-pequena"></i> Dados do proponente
      </h3>
      <div class="u-padding-esquerda-grande u-margem-superior-media u-margem-inferior-grande">
        <div v-for="(proponente, index) in solicitacao.Proponentes">
          <span class="titulo titulo_pequeno">
            {{ index + 1 }}º Proponente
          </span>
          <div class="field is-horizontal u-margem-inferior-media">
            <div class="linha u-margem-superior-media">
              <div class="field coluna">
                <span class="label">
                  <strong>Nome:</strong>
                </span>
                <span>{{ proponente.Nome }}</span>
              </div>
              <div class="field coluna">
                <span class="label">
                  <strong>CPF:</strong>
                </span>
                <span>{{ proponente.Cpf }}</span>
              </div>
              <div class="field coluna">
                <span class="label">
                  <strong>Telefone: </strong>
                </span>
                <span>{{ proponente.Telefone || 'NÃO INFORMADO' }}</span>
              </div>
            </div>
          </div>
          <div v-if="proponente.Conjuge">
            <span class="titulo titulo_pequeno">
              {{ index + 1 }}º Cônjuge
            </span>
            <div class="field is-horizontal u-margem-inferior-grande">
              <div class="linha u-margem-superior-pequena">
                <div class="field coluna">
                  <span class="label">
                    <strong>Nome:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Nome }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>CPF:</strong>
                  </span>
                  <span>{{ proponente.Conjuge.Cpf }}</span>
                </div>
                <div class="field coluna">
                  <span class="label">
                    <strong>Telefone: </strong>
                  </span>
                  <span>{{ proponente.Conjuge.Telefone || 'NÃO INFORMADO' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4 u-sem-padding">
            <label class="formulario__label">Renda familiar comprovada*</label>
            <input class="formulario__input u-margem-superior-pequena" type="text" placeholder="10.000,00"
              @blur="validarEnquadramentoDaNovaRenda" v-model="solicitacao.RendaFamiliarComprovada" v-mask="'money'"
              required @keydown.enter.prevent />
          </div>
        </div>
      </div>
      <h3
        class="subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-grande">
        <i class="fal fa-home negrito icone-de-titulo u-margem-direita-pequena"></i> Dados do imóvel
      </h3>
      <div class="u-padding-esquerda-media">
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label">Cidade</label>
            <input name="cidade" type="text" id="cidade" class="formulario__input" v-model="solicitacao.Cidade"
              disabled />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="matricula">Matrícula*</label>
            <input name="matricula" type="tel" id="matricula" class="formulario__input" placeholder="Somente números"
              v-model="solicitacao.Matricula" disabled />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="cep">APF*</label>
            <input name="cep" type="tel" id="cep" class="formulario__input" placeholder="Somente números"
              v-model="solicitacao.Apf" disabled />
          </div>
        </div>
        <div class="grade__linha ">
          <div class="grade__coluna grade__coluna_8">
            <label class="formulario__label">Empreendimento*</label>
            <input name="tipo-de-empreendimento" type="text" id="tipo-de-empreendimento" class="formulario__input"
              v-model="solicitacao.Empreendimento" disabled />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label">Tipo do imóvel*</label>
            <select v-model="solicitacao.TipoDeImovel" required class="formulario__input" @change="verificarSeImovelEhApartamento">
              <option v-for="tipoDeImovel in tiposDeImovel" :value="tipoDeImovel.Id"
                :selected="tipoDeImovel.Id === solicitacao.TipoDeImovel ? 'selected' : ''">
                {{ tipoDeImovel.Nome }}
              </option>
            </select>
          </div>
        </div>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_5">
            <label class="formulario__label">Construtora</label>
            <input name="nome-da-construtora" type="text" id="nome-da-construtora" class="formulario__input"
              v-model="solicitacao.ConstrutoraNome" disabled />
          </div>
          <div class="grade__coluna grade__coluna_3">
            <label class="formulario__label">CNPJ</label>
            <input name="cpnj" type="text" id="cnpj" class="formulario__input" v-model="solicitacao.ConstrutoraCnpj"
              disabled />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label">Conta</label>
            <input name="conta-da-construtora" type="text" id="conta-da-construtora" class="formulario__input"
              v-model="solicitacao.ConstrutoraConta" disabled />
          </div>
        </div>
        <div class="grade__linha ">
          <div class="grade__coluna grade__coluna_3">
            <label class="formulario__label" for="tipo-do-logradouro">Tipo do logradouro*</label>
            <select class="formulario__input" v-model="solicitacao.TipoDeLogradouroId" required>
              <option v-for="tipoDeLogradouro in tiposDeLogradouro" :value="tipoDeLogradouro.Id"
                :selected="tipoDeLogradouro.Id === solicitacao.TipoDeLogradouroId ? 'selected' : ''">
                {{ tipoDeLogradouro.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_6">
            <label class="formulario__label" for="logradouro">Logradouro*</label>
            <input id="logradouro" class="formulario__input" type="text" maxlenght="90" name="logradouro"
              placeholder="Ex: Afonso Pena, da Divisão, Lídia Baís, etc." v-model="solicitacao.Logradouro" required />
          </div>
          <div class="grade__coluna grade__coluna_3">
            <label class="formulario__label" for="numero">Número*</label>
            <input id="numero" class="formulario__input" type="number" placeholder="EX: 481"
              v-model="solicitacao.Numero" number required />
          </div>
        </div>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_3">
            <label class="formulario__label" for="cep">CEP*</label>
            <input name="cep" type="tel" id="cep" class="formulario__input" placeholder="Somente números"
              v-model="solicitacao.Cep" v-mask="'99999-999'" required />
          </div>
          <div class="grade__coluna grade__coluna_3">
            <label class="formulario__label" for="bairro">Bairro*</label>
            <input id="bairro" class="formulario__input" name="bairro" type="text" maxlenght="90"
              placeholder="Ex: Centro, Santa Fé, Vila Carvalho..." v-model="solicitacao.Bairro" required />
          </div>
          <div class="grade__coluna grade__coluna_1">
            <label class="formulario__label" for="bloco" v-if="solicitacao.EhApartamento">Bloco* </label>
            <label class="formulario__label" for="quadra" v-else>Quadra*</label>
            <input id="quadra" class="formulario__input" v-model="solicitacao.BlocoOuQuadra" type="text" maxlenght="90"
              placeholder="Ex: 1" required />
          </div>
          <div class="grade__coluna grade__coluna_1">
            <label class="formulario__label" for="apartamento" v-if="solicitacao.EhApartamento">Ap*
            </label>
            <label class="formulario__label" for="lote" v-else>Lote*</label>
            <input id="lote" class="formulario__input" v-model="solicitacao.ApartamentoOuLote" type="text"
              maxlenght="90" placeholder="Ex: A" required />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="complemento">Complemento</label>
            <input id="complemento" class="formulario__input" type="text" maxlenght="90" placeholder="Ex: Casa 2"
              v-model="solicitacao.Complemento" />
          </div>
        </div>
      </div>
      <h3
        class="subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-grande">
        <i class="fal fa-sack-dollar icone-de-titulo u-margem-direita-pequena"></i> Dados do financiamento
      </h3>
      <div class="u-padding-esquerda-media">
        <div class="">
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="valor-da-compra-e-venda">
                Valor de compra e venda*
              </label>
              <input id="valor-da-compra-e-venda" class="formulario__input" type="text" placeholder="130.000,00"
                v-model="solicitacao.ValorDaCompraEVenda" v-mask="'money'" required />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="valor-do-financiamento-aprovado">Valor do financiamento*</label>
              <input id="valor-do-financiamento-aprovado" class="formulario__input" type="text" placeholder="90.000,00"
                v-model="solicitacao.ValorDoFinanciamentoAprovado" v-mask="'money'" required />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="subsidio-governo-federal">Subsídio do Governo Federal*</label>
              <input id="subsidio-governo-federal" class="formulario__input" type="text" placeholder="14.000,00"
                v-model="solicitacao.SubsidioDoGovernoFederal" v-mask="'money'" />
            </div>
          </div>
        </div>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="valor-de-avaliacao">Valor de avaliação*</label>
            <input id="valor-de-avaliacao" class="formulario__input" type="text" placeholder="130.000,00"
              v-model="solicitacao.ValorDeAvaliacao" v-mask="'money'" required />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="data-de-avaliacao">Data de avaliação*</label>
            <input id="data-de-avaliacao" class="formulario__input" type="date" v-model="solicitacao.DataDeAvaliacao"
              disabled />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="codigo-de-avaliacao">Código de avaliação*</label>
            <input id="codigo-de-avaliacao" class="formulario__input" type="number" placeholder="Somente números"
              v-model="solicitacao.CodigoDeAvaliacao" number disabled />
          </div>
        </div>
        <div class="grade__linha u-padding-esquerda-pequena">
          <p class="u-margem-inferior-pequena titulo-negrito">
            <strong> Recursos Próprios </strong>
          </p>
        </div>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="desconto-da-construtora">Desconto da construtora na entrada</label>
            <input id="desconto-da-construtora" class="formulario__input" type="text" placeholder="10.000,00"
              v-model="solicitacao.DescontoConstrutora" v-mask="'money'" />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="participacao-necessaria">Participação do proponente*</label>
            <input id="participacao-necessaria" class="formulario__input" type="text" placeholder="10.000,00"
              v-model="solicitacao.ParticipacaoDoSolicitante" v-mask="'money'" />
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="subsidio-solicitado-agehab">Subsídio solicitado AGEHAB*</label>
            <input name="valorDoSubsidioDaAgehab" type="text" id="valorDoSubsidioDaAgehab" class="formulario__input"
              v-model="solicitacao.SubsidioDaAgehab" disabled />
          </div>
        </div>
      </div>
      <div class="grade__linha grade__linha_alinhar-horizontal-direita u-margem-superior-grande">
        <router-link
          :to="{ name: 'DetalhesDaSolicitacaoParaMcmvCidades', query: { idDaSolicitacao: this.$route.query.idDaSolicitacao } }"
          class="botao botao_cinza botao_medio" :class="{ 'is-disabled': loading.visivel }">Cancelar</router-link>
        <button type="submit" class="botao botao_medio botao_cor-terciaria u-margem-esquerda-media"
          :class="{ 'is-loading': loading.visivel }">Avançar</button>
      </div>
    </form>
    <modal v-if="modalDeIndeferimentoEstaVisivel" @close="fecharModalDeIndeferimento">
      <form @submit.prevent="cancelarSolicitacao" class="formulario">
        <h3 class="titulo titulo_medio u-margem-inferior-media">Edição das informações da solicitação</h3>
        <hr class="u-margem-inferior-media">
        <div class="grade__linha grade__linha_alinhar-horizontal-centro u-margem-inferior-media">
          <div role="alert" class="grade__coluna mensagem mensagem_cor-atencao u-sem-margem">
            <i class="far fa-exclamation-circle mensagem__icone"></i>
            <div class="mensagem__conteudo">
              <h2 class="mensagem__titulo">Fique atento:</h2>
              <p class="mensagem__texto mensagem-cancelamento">A renda familiar comprovada foi editada e não se encaixa
                na mesma faixa. Ao
                completar essa ação, a solicitação será indeferida.</p>
            </div>
          </div>
        </div>
        <div>
          <p class="mensagem-confirmacao u-margem-inferior-media">
            <strong>Tem certeza que deseja editar as informações?</strong>
          </p>
        </div>
        <hr class="u-margem-inferior-media">
        <div class="grade__linha_alinhar-horizontal-direita formulario-button">
          <button type="button" @click="fecharModalDeIndeferimento"
            class="botao botao_cinza botao_medio u-margem-direita-pequena">Cancelar</button>
          <button type="submit" class="botao botao_cor-terciaria botao_medio"
            :class="{ 'is-loading': loading.visivel }">Confirmar</button>
        </div>
      </form>
    </modal>
    <modal v-if="modalDeEdicaoEstaVisivel" @close="fecharModalDeEdicao">
      <form @submit.prevent="editarSolicitacao" class="formulario">
        <h3 class="titulo titulo_medio u-margem-inferior-media">Edição das informações da solicitação</h3>
        <hr class="u-margem-inferior-grande">
        <div>
          <p class="mensagem-confirmacao u-margem-inferior-grande">
            <strong>Tem certeza que deseja editar as informações?</strong>
          </p>
        </div>
        <div class="grade__linha_alinhar-horizontal-direita formulario-button">
          <button type="button" @click="fecharModalDeEdicao"
            class="botao botao_cinza botao_medio u-margem-direita-pequena">Cancelar</button>
          <button type="submit" class="botao botao_cor-terciaria botao_medio"
            :class="{ 'is-loading': loading.visivel }">Confirmar</button>
        </div>
      </form>
    </modal>
    <MensagemFlutuante :mensagemVisivel="mensagemVisivel" :titulo="tituloMensagem" :estilo="estiloMensagem"
      :texto="textoMensagem" @close="fecharMensagem" />
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import Loading from '../../shared/Loading.vue'
import MensagemFlutuante from '../../shared/MensagemFlutuante';
import Modal from '../../shared/Modal';

export default {
  name: 'editar-valores-da-solicitacao-para-mcmv-cidades',
  directives: { mask: AwesomeMask },
  components: { Loading, MensagemFlutuante, Modal },
  data() {
    return {
      loading: {
        visivel: false,
      },
      solicitacao: {
        Proponentes: [],
        RendaFamiliarComprovada: null,
        RendaFamiliarComprovadaAntesDaAlteracao: null,
        TipoDeImovel: null,
        TipoDeLogradouroId: null,
        Logradouro: null,
        Numero: null,
        Cep: null,
        Bairro: null,
        Complemento: null,
        BlocoOuQuadra: null,
        ApartamentoOuLote: null,
        EhApartamento: false,
        ValorDaCompraEVenda: null,
        ValorDoFinanciamentoAprovado: null,
        SubsidioDoGovernoFederal: null,
        ParticipacaoDoSolicitante: null,
        SubsidioDaAgehab: null,
        DescontoConstrutora: null,
        ValorDeAvaliacao: null,
        CodigoDeAvaliacao: null,
        DataDeAvaliacao: null,
        Cidade: null,
        Matricula: null,
        Apf: null,
        Empreendimento: null,
        Construtora: {}
      },
      tiposDeLogradouro: [],
      tiposDeImovel: [
        { Id: null, Nome: 'Selecione um tipo de imóvel' },
        { Id: 1, Nome: 'Apartamento' },
        { Id: 2, Nome: 'Casa' },
      ],
      mensagemVisivel: false,
      textoMensagem: '',
      estiloMensagem: '',
      tituloMensagem: '',
      modalDeIndeferimentoEstaVisivel: false,
      modalDeEdicaoEstaVisivel: false
    };
  },
  computed: {
    construtora() {
      const empreedimentoId = this.solicitacao.EmpreendimentoId;
      const empreendimento = this.empreendimentos.find(e => e.Id === empreedimentoId);
      return empreendimento ? empreendimento.Construtora : {};
    }
  },
  created() {
    this.exibirCarregamento();
    this.obterTiposDeLogradouro().then(() => {
      this.obterSolicitacao().then((response) => {
        this.solicitacao = this.criarSolicitacao(response.data);
        if (!this.solicitacao.AcoesPermitidas.PermiteEdicao) {
          this.exibirMensagemDeErro("Solicitação não pode ser alterada!");
          setTimeout(() => { this.redirecionarParaResumoDaSolicitacao() }, 1500);
        }
      });
    }).catch((error) => {
      this.tratarErro(error);
    }).finally(() => {
      this.esconderCarregamento();
    });
  },
  methods: {
    formatarComAnoMesDia(dataSemFormatacao) {
      const data = new Date(dataSemFormatacao);
      return data && new Date(data.getTime() - (data.getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0]
    },
    exibirCarregamento() {
      this.loading.visivel = true;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
    },
    obterTiposDeLogradouro() {
      return new Promise((resolve, reject) => {
        this.$api.get('/TipoDeLogradouro').then((response) => {
          this.tiposDeLogradouro = [{ Id: null, Nome: 'Selecione um tipo' }];
          this.tiposDeLogradouro = this.tiposDeLogradouro.concat(response.data);
          resolve(true);
        }, (error) => {
          reject(error);
        });
      });
    },
    obterSolicitacao() {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      return new Promise((resolve, reject) => {
        this.$api.get(`/solicitacao/${idDaSolicitacao}`).then((response) => {
          resolve(response);
        }, (error) => {
          reject(error);
        });
      });
    },
    editarSolicitacao() {
      let url = 'Solicitacao/McmvCidades/Alterar';
      let parametrosParaAlterarSolicitacaoDto = this.criarParametrosParaAlterarSolicitacaoDto(this.solicitacao);

      this.exibirCarregamento();
      this.$api.post(url, parametrosParaAlterarSolicitacaoDto).then(() => {
        this.fecharModalDeEdicao();
        this.exibirMensagemDeSucesso("Informações editadas com sucesso!");
        setTimeout(() => { this.redirecionarParaResumoDaSolicitacao() }, 1500);
      }).catch((error) => {
        this.tratarErro(error);
      }).finally(() => {
        this.esconderCarregamento();
      });
    },
    validarEnquadramentoDaNovaRenda() {
      let url = 'Solicitacao/McmvCidades/NovaRendaSeEnquadraEmOutraFaixa';
      let parametrosParaValidarEnquadramentoDaNovaRendaDto = {
        SolicitacaoId: this.$route.query.idDaSolicitacao,
        NovaRendaFamiliarComprovada: this.$moeda.removerFormatacao(this.solicitacao.RendaFamiliarComprovada)
      };

      this.exibirCarregamento();
      this.$api.post(url, parametrosParaValidarEnquadramentoDaNovaRendaDto).then((response) => {
        let novaRendaAlteraFaixaDeEnquadramento = response.data;
        if (novaRendaAlteraFaixaDeEnquadramento)
          this.abrirModalDeIndeferimento();
      }).catch((error) => {
        this.tratarErro(error);
      }).finally(() => {
        this.esconderCarregamento();
      });
    },
    tratarErro(error) {
      const mensagensDeErro = error.response.data.Message;
      let mensagem;

      if (mensagensDeErro)
        mensagem = mensagensDeErro.split(',').join('<br />');
      else
        mensagem = 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';

      this.exibirMensagemDeErro(mensagem);
    },
    exibirMensagemDeSucesso(mensagem) {
      let estiloDaMensagem = 'sucesso';
      let tituloDaMensagem = 'Concluído'
      this.exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem);
    },
    exibirMensagemDeErro(mensagem) {
      let estiloDaMensagem = 'erro';
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
      this.mensagemVisivel = true;
      this.textoMensagem = mensagem;
      this.estiloMensagem = estiloDaMensagem;
      this.tituloMensagem = tituloDaMensagem || '';
      setTimeout(() => { this.fecharMensagem() }, 10000);
    },
    fecharMensagem() {
      this.mensagemVisivel = false;
    },
    criarSolicitacao(solicitacao) {
      const financiamento = solicitacao.Financiamento;
      const imovel = solicitacao.Imovel;
      const construtora = imovel.Empreendimento.Construtora;
      return {
        ...solicitacao,
        RendaFamiliarComprovada: this.$moeda.formatar(solicitacao.RendaTotalComprovada),
        RendaFamiliarComprovadaAntesDaAlteracao: this.$moeda.formatar(solicitacao.RendaTotalComprovada),
        ValorDaCompraEVenda: this.$moeda.formatar(financiamento.ValorDaCompraEVenda),
        ValorDeAvaliacao: this.$moeda.formatar(financiamento.ValorDeAvaliacao),
        ValorDoFinanciamentoAprovado: this.$moeda.formatar(financiamento.ValorDoFinanciamentoAprovado),
        SubsidioDoGovernoFederal: this.$moeda.formatar(financiamento.SubsidioDoGovernoFederal),
        DataDeAvaliacao: this.formatarComAnoMesDia(financiamento.DataDeAvaliacao),
        DescontoConstrutora: this.$moeda.formatar(financiamento.DescontoConstrutora),
        ParticipacaoDoSolicitante: this.$moeda.formatar(financiamento.ParticipacaoDoSolicitante),
        SubsidioDaAgehab: this.$moeda.formatar(financiamento.SubsidioDaAgehab),
        CodigoDeAvaliacao: financiamento.CodigoDeAvaliacao,
        Cidade: imovel.Empreendimento.Cidade.Nome,
        Matricula: imovel.Matricula,
        Apf: imovel.Apf,
        Logradouro: imovel.Endereco.Logradouro,
        TipoDeLogradouroId: imovel.Endereco.TipoDeLogradouroId,
        Numero: imovel.Endereco.NumeroDoImovel,
        Cep: imovel.Endereco.Cep,
        Bairro: imovel.Endereco.Bairro,
        BlocoOuQuadra: imovel.Endereco.BlocoOuQuadra,
        ApartamentoOuLote: imovel.Endereco.ApartamentoOuLote,
        Complemento: imovel.Endereco.Complemento,
        Empreendimento: imovel.Empreendimento.Nome,
        TipoDeImovel: imovel.TipoDoImovel,
        EhApartamento: imovel.EhApartamento,
        ConstrutoraNome: construtora.Nome,
        ConstrutoraCnpj: construtora.Cnpj,
        ConstrutoraConta: construtora.Conta
      };
    },
    criarParametrosParaAlterarSolicitacaoDto(solicitacao) {
      return {
        SolicitacaoId: this.$route.query.idDaSolicitacao,
        RendaFamiliarComprovada: this.$moeda.removerFormatacao(solicitacao.RendaFamiliarComprovada),
        TipoDeImovel: solicitacao.TipoDeImovel,
        TipoDeLogradouroId: solicitacao.TipoDeLogradouroId,
        Logradouro: solicitacao.Logradouro,
        Numero: solicitacao.Numero,
        Cep: solicitacao.Cep,
        Bairro: solicitacao.Bairro,
        Complemento: solicitacao.Complemento,
        BlocoOuQuadra: solicitacao.BlocoOuQuadra,
        ApartamentoOuLote: solicitacao.ApartamentoOuLote,
        ValorDaCompraEVenda: this.$moeda.removerFormatacao(solicitacao.ValorDaCompraEVenda),
        ValorDoFinanciamentoAprovado: this.$moeda.removerFormatacao(solicitacao.ValorDoFinanciamentoAprovado),
        SubsidioDoGovernoFederal: this.$moeda.removerFormatacao(solicitacao.SubsidioDoGovernoFederal),
        ParticipacaoDoSolicitante: this.$moeda.removerFormatacao(solicitacao.ParticipacaoDoSolicitante),
        SubsidioDaAgehab: this.$moeda.removerFormatacao(solicitacao.SubsidioDaAgehab),
        DescontoConstrutora: this.$moeda.removerFormatacao(solicitacao.DescontoConstrutora),
        ValorDeAvaliacao: this.$moeda.removerFormatacao(solicitacao.ValorDeAvaliacao)
      };
    },
    redirecionarParaResumoDaSolicitacao() {
      this.$router.push({ name: 'DetalhesDaSolicitacaoParaMcmvCidades', query: { idDaSolicitacao: this.$route.query.idDaSolicitacao } });
    },
    abrirModalDeIndeferimento() {
      this.modalDeIndeferimentoEstaVisivel = true;
    },
    fecharModalDeIndeferimento() {
      this.solicitacao.RendaFamiliarComprovada = this.solicitacao.RendaFamiliarComprovadaAntesDaAlteracao;
      this.modalDeIndeferimentoEstaVisivel = false;
    },
    abrirModalDeEdicao() {
      this.modalDeEdicaoEstaVisivel = true;
    },
    fecharModalDeEdicao() {
      this.modalDeEdicaoEstaVisivel = false;
    },
    cancelarSolicitacao() {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      let urlDeCancelamentoDeSolicitacao = `/solicitacao/McmvCidades/${idDaSolicitacao}/Cancelar`;
      let justificativa = 'Cancelado devido ao desenquadramento por alteração da renda familiar comprovada';

      this.exibirCarregamento('Só um momento, estamos cancelando a solicitação');
      this.$api.post(urlDeCancelamentoDeSolicitacao, { Justificativa: justificativa }).then(() => {
        this.fecharModalDeIndeferimento();
        this.exibirMensagemDeSucesso('A solicitação foi cancelada com sucesso');
        setTimeout(() => { this.redirecionarParaResumoDaSolicitacao() }, 1500);
      }).catch((error) => {
        this.tratarErro(error);
        this.fecharModalDeIndeferimento();
      });
    },
    verificarSeImovelEhApartamento() {
      const apartamento = 1;
      const ehApartamento = this.solicitacao.TipoDeImovel === apartamento;
      this.solicitacao.EhApartamento = ehApartamento;
    }
  }
};
</script>


// WEBPACK FOOTER //
// EditarValoresDaSolicitacaoParaMcmvCidades.vue?2fd07d86